import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d028056"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "modal-footer d-flex justify-content-center"
}

import { computed } from 'vue'

interface ModalEmits {
  (event: 'update:modelValue', isShow: boolean): void
  (event: 'cancel'): void
  (event: 'ok'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWindow',
  props: {
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: '' },
  size: { type: String, default: '' },
  centered: { type: Boolean, default: false },
  scrollable: { type: Boolean, default: true },
  hideFooter: { type: Boolean, default: false },
  cancelTitle: { type: String, default: 'キャンセル' },
  okTitle: { type: String, default: 'OK' },
  okVariant: { type: String, default: 'primary' },
},
  emits: ["update:modelValue", "cancel", "ok"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:modelValue', isShow: boolean): void
  (event: 'cancel'): void
  (event: 'ok'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const modalClasses = computed(() => [
  {
    'd-block': props.modelValue,
  }
])

const modalDialogClasses = computed(() => [
  {
    [`modal-${props.size}`]: props.size,
    'modal-dialog-centered': props.centered,
    'modal-dialog-scrollable': props.scrollable
  }
])

const okButtonClasses = computed(() => `btn btn-${props.okVariant} mx-2`)

const hide = () => {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal", _unref(modalClasses)]),
      tabindex: "-1"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog", _unref(modalDialogClasses)])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("h5", _hoisted_3, _toDisplayString(__props.title), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "閉じる",
              onClick: hide
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          (!__props.hideFooter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "footer", {}, () => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary mx-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (hide(), _ctx.$emit('cancel')))
                  }, _toDisplayString(__props.cancelTitle), 1),
                  _renderSlot(_ctx.$slots, "footerButton", {}, () => [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(_unref(okButtonClasses)),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (hide(), _ctx.$emit('ok')))
                    }, _toDisplayString(__props.okTitle), 3)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2)
  ]))
}
}

})